<template>
  <custom-callout
    class="my-4 comment-callout-styles"
    :has-toggle="false"
    border-color="orange"
  >
    <icon-view
      class="mt-5 mb-3 mt-md-0 mt-sm-5 comment-callout-icon"
      :title="title"
      :icon="icon"
      :icon-background="iconBackground"
      :icon-color="iconColor"
      :icon-size="iconSize"
    />
    <validation-observer ref="commentRef">
      <div class="row">
        <div class="col-12">
          <validation-provider rules="required" v-slot="{ errors }">
            <custom-text-area
              id="comment-callout-text-area"
              v-model="value"
              :maxlength="maxCommentLenght"
              placeholder="Escribe un comentario"
              :show-char-count="showCharCounter"
              :count-classes="['d-block', 'text-right', 'text-gray', 'mr-1']"
              :error="errors[0]"
              :custom-error-msg="customValidationMessage"
              label="Comentario:"
              :disabled="disabled"
            />
          </validation-provider>
        </div>
        <div v-if="!disabled" class="col-12 my-4 d-flex justify-content-end">
          <action-button
            id="comment-callout-cancel-btn"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mr-3 pl-3 pr-4"
            @click="$emit('on-cancel')"
          />
          <action-button
            id="comment-callout-save-btn"
            i="fas fa-save"
            text="Guardar"
            variant="success pl-3 pr-3"
            @click="onSave()"
          />
        </div>
      </div>
    </validation-observer>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import IconView from 'icon-view';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';

export default {
  name: 'CommentCallout',
  components: {
    CustomCallout,
    IconView,
    CustomTextArea,
    ActionButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    comment: {
      type: String,
      default: '',
    },
    iconBackground: {
      type: String,
      default: 'white',
    },
    iconColor: {
      type: String,
      default: '#ff7058',
    },
    iconSize: {
      type: String,
      default: '16px',
    },
    maxCommentLenght: {
      type: Number,
      default: 3000,
    },
    showCharCounter: {
      type: Boolean,
      default: true,
    },
    customValidationMessage: {
      type: String,
      default: 'La razón es requerida.',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: '',
    };
  },
  watch: {
    comment(newVal) {
      this.value = newVal;
    },
  },
  created() {
    if (this.comment) {
      this.value = this.comment;
    }
  },
  methods: {
    async onSave() {
      const isValid = await this.$refs.commentRef.validate();
      if (!isValid) {
        return;
      } else {
        this.$emit('on-save', this.value);
      }
    },
  },
};
</script>

<style>
.comment-callout-icon > * em {
  margin-top: 0 !important;
}

.comment-callout-styles > * label {
  font-weight: normal;
}

.comment-callout-styles > * textarea:disabled {
  background: #e2e2e2 !important;
}
</style>
